// #region imports

// --- Angular
import { ModuleWithProviders } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

// --- HS Code
import { AuthGuard } from './core/guards/auth.guard';
import * as c from './';

// #endregion

export const routes: Route[] = [
  { path: '', pathMatch: 'full', loadChildren: './home/home.module#HomeModule' },
  { path: 'dashboard', canActivate: [AuthGuard], loadChildren: './dashboard/dashboard.module#DashboardModule'},
  { path: 'surveys', canActivate: [AuthGuard], loadChildren: './survey/survey.module#SurveyModule'},
  //{ path: 'reports', canActivate: [AuthGuard], loadChildren: './reports/reports.module#ReportsModule'},
  { path: 'reports/:id', canActivate: [AuthGuard], loadChildren: './reports/reports.module#ReportsModule'},
  { path: 'profile', canActivate: [AuthGuard], loadChildren: './profile/profile.module#ProfileModule'},
  { path: 'error', canActivate: [AuthGuard], component: c.ErrorComponent, pathMatch: 'full' },
  { path: '**', pathMatch: 'full', redirectTo: 'error/404' }
];
